// extracted by mini-css-extract-plugin
module.exports = {"next-sr-only":"DetailModal--next-sr-only--c8sFXCI","attachment":"DetailModal--attachment--2cVw6dt"};